const maps = [
  "https://portfolio-k3s-uploads.s3.ap-southeast-1.amazonaws.com/Maps/first.jpg",
  "https://portfolio-k3s-uploads.s3.ap-southeast-1.amazonaws.com/Maps/second.jpg",
  "https://portfolio-k3s-uploads.s3.ap-southeast-1.amazonaws.com/Maps/third.jpg",
];

export default maps;
